<div class="main">
    <section class="testimonials product-listing">
        <!-- decorative layered background -->
        <div class="pl-bg" aria-hidden="true"></div>

        <div class="container">
            <header class="header">
                <p class="eyebrow"><i class="fa-solid fa-shield-halved"></i> LegalStack Services</p>
                <h1 class="heading">{{ categoryTitle }} Services <span class="grad">Online</span></h1>
                <p class="subheading">
                    Choose a {{ categoryTitle }} plan and get it done online with verified CAs &amp; legal experts —
                    transparent pricing, no hidden charges.
                </p>

                <ul class="trust-row">
                    <li><i class="fa-solid fa-user-check"></i> Verified CAs &amp; lawyers</li>
                    <li><i class="fa-solid fa-tag"></i> Transparent pricing</li>
                    <li><i class="fa-solid fa-bolt"></i> 100% online process</li>
                </ul>

                <p class="result-count" *ngIf="loaded && pujaList?.length">
                    Showing {{ pujaList.length }} {{ pujaList.length === 1 ? 'plan' : 'plans' }}
                </p>
            </header>

            <div class="card-container">
                <!-- skeleton placeholders while the plans load -->
                <div class="product-grid" *ngIf="!loaded" aria-hidden="true">
                    <div class="card skeleton" *ngFor="let s of [1,2,3,4,5,6]">
                        <div class="sk-media"></div>
                        <div class="sk-body">
                            <span class="sk-line w80"></span>
                            <span class="sk-line w95"></span>
                            <span class="sk-line w60"></span>
                            <span class="sk-btn"></span>
                        </div>
                    </div>
                </div>

                <div class="product-grid" *ngIf="loaded && pujaList?.length">
                    <article class="card" *ngFor="let item of pujaList"
                        [class.disabled-card]="!item?.productUrl"
                        (click)="item?.productUrl && gotodetailspage(item.productUrl)">
                        <div class="card-media">
                            <img [src]="item?.productImage" class="imgBlog"
                                [alt]="item?.productName ? item?.productName + ' — LegalStack' : 'LegalStack service'"
                                loading="lazy" />
                            <span class="media-badge"><i class="fa-solid fa-circle-check"></i> Verified experts</span>
                        </div>
                        <div class="card-content">
                            <h3 class="card-title">{{ item?.productName }}</h3>
                            <p class="card-desc">{{ item?.productShortDesc }}</p>

                            <div class="card-foot">
                                <div class="price" *ngIf="item?.productPrice">
                                    <span class="price-label">Starts at</span>
                                    <span class="price-val">₹{{ item?.productPrice }}</span>
                                </div>

                                <div class="addToCart">
                                    <button type="button" class="btn-book" [disabled]="!item?.productUrl"
                                        (click)="onBookNow(item, $event)"
                                        [attr.aria-label]="'Book ' + (item?.productName || 'service')">
                                        <span>Book Now</span>
                                        <i class="fa-solid fa-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>

                <div class="empty-state" *ngIf="loaded && !pujaList?.length">
                    <div class="empty-icon"><i class="fa-regular fa-folder-open"></i></div>
                    <p class="empty-title">No plans available right now</p>
                    <p class="empty-sub">Please check back soon — new {{ categoryTitle }} services are added
                        regularly.</p>
                </div>
            </div>
        </div>
    </section>
</div>
